import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { HoverCard as RichTooltipPrimitive } from 'radix-ui';

/**
 * If you want to check the original component, from shadcn, please check the `hover-card` component: https://ui.shadcn.com/docs/components/hover-card
 */
function RichTooltip({
  ...props
}: Readonly<React.ComponentProps<typeof RichTooltipPrimitive.Root>>) {
  return <RichTooltipPrimitive.Root data-slot="hover-card" {...props} />;
}

function RichTooltipTrigger({
  ...props
}: React.ComponentProps<typeof RichTooltipPrimitive.Trigger>) {
  return (
    <RichTooltipPrimitive.Trigger data-slot="hover-card-trigger" {...props} />
  );
}

function RichTooltipContent({
  className,
  align = 'center',
  side = 'top',
  sideOffset = 4,
  container,
  ...props
}: React.ComponentProps<typeof RichTooltipPrimitive.Content> & {
  container?: React.ComponentProps<
    typeof RichTooltipPrimitive.Portal
  >['container'];
}) {
  return (
    <RichTooltipPrimitive.Portal
      data-slot="hover-card-portal"
      container={container}
    >
      <RichTooltipPrimitive.Content
        data-slot="hover-card-content"
        align={align}
        side={side}
        sideOffset={sideOffset}
        className={cn(
          'z-tooltip origin-(--radix-hover-card-content-transform-origin) rounded-sm border border-border-tertiary bg-ui-primary px-4 py-3 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.25)] outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
          className,
        )}
        {...props}
      />
    </RichTooltipPrimitive.Portal>
  );
}

function RichTooltipAggrid({
  type = 'info',
  ...props
}: Readonly<React.ComponentProps<'div'> & { type: 'error' | 'info' }>) {
  return (
    <div
      data-slot="hover-card-aggrid"
      {...props}
      data-type={type}
      className={cn(
        'flex items-center gap-2 rounded-sm border border-border-tertiary bg-ui-primary px-3 py-2 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.25)] outline-hidden data-[type=error]:fill-text-error data-[type=error]:text-text-error data-[type=info]:fill-text-primary data-[type=info]:text-text-primary',
        props.className,
      )}
    />
  );
}

export {
  RichTooltip,
  RichTooltipTrigger,
  RichTooltipContent,
  RichTooltipAggrid,
};
